<button
  class="viz-toolbar-button"
  [class.disabled]="disabled"
  [disabled]="disabled"
  #totalsMenuTrigger="matMenuTrigger"
  aria-label="Totals"
  [class.open]="totalsMenuTrigger.menuOpen"
  [matMenuTriggerFor]="totalsMenu"
>
  <capra-icon class="total-icon" icon="icon-control-total" [class.analyst-studio]="isAnalystStudio"></capra-icon>
  <capra-icon [icon]="isAnalystStudio ? 'icon-chevron-mini' : 'icon-caret-mini'" class="menu-icon"></capra-icon>
</button>
<mat-menu #totalsMenu="matMenu" class="select-menu totals-menu">
  <ng-container *ngIf="isSubtotalsFFEnabled$ | async; then newWithSubtotals; else noSubtotals"></ng-container>
</mat-menu>
<!--
  Old grand totals only menu
  Used when subtotals FF is OFF
  The ng-container above and this template can be completely removed when the FF
  has been enabled/removed
-->
<ng-template #noSubtotals>
  <button
    mat-menu-item
    [class.selected]="isColGrandTotalEnabled"
    (click)="toggleColumnGrandTotal()"
    [disabled]="!isColGrandTotalAllowed"
  >
    <capra-icon icon="icon-check" *ngIf="isColGrandTotalEnabled"></capra-icon>
    Show column grand total
  </button>
  <button
    mat-menu-item
    [class.selected]="isRowGrandTotalEnabled"
    (click)="toggleRowGrandTotal()"
    [disabled]="!isRowGrandTotalAllowed"
  >
    <capra-icon icon="icon-check" *ngIf="isRowGrandTotalEnabled"></capra-icon>
    Show row grand total
  </button>
</ng-template>
<!--
  New menu for both grand and subtotals
  Used when subtotals FF is ON
  The code within this template should be inserted in the menu above
  when the FF is removed.
-->
<ng-template #newWithSubtotals>
  <div class="section" data-test="section-columns">
    <span class="section-text">Columns</span>
  </div>
  <button
    mat-menu-item
    [class.selected]="isColGrandTotalEnabled"
    (click)="toggleColumnGrandTotal()"
    [disabled]="!isColGrandTotalAllowed"
  >
    <capra-icon icon="icon-check" *ngIf="isColGrandTotalEnabled"></capra-icon>
    Grand totals
  </button>
  <button
    mat-menu-item
    [class.selected]="isColSubtotalsEnabled"
    (click)="toggleColumnSubtotals()"
    [disabled]="!isColSubtotalsAllowed"
  >
    <capra-icon icon="icon-check" *ngIf="isColSubtotalsEnabled"></capra-icon>
    Subtotals
  </button>
  <mat-divider></mat-divider>
  <div class="section" data-test="section-rows">
    <span class="section-text">Rows</span>
  </div>
  <button
    mat-menu-item
    [class.selected]="isRowGrandTotalEnabled"
    (click)="toggleRowGrandTotal()"
    [disabled]="!isRowGrandTotalAllowed"
  >
    <capra-icon icon="icon-check" *ngIf="isRowGrandTotalEnabled"></capra-icon>
    Grand totals
  </button>
  <button
    mat-menu-item
    [class.selected]="isRowSubtotalsEnabled"
    (click)="toggleRowSubtotals()"
    [disabled]="!isRowSubtotalsAllowed"
  >
    <capra-icon icon="icon-check" *ngIf="isRowSubtotalsEnabled"></capra-icon>
    Subtotals
  </button>
</ng-template>
